import * as React from "react";

const DateInput = (props: any) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="a" d="M0 0h48v21H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(8 19)">
        <use fill="#FFF" xlinkHref="#a" />
        <path stroke="#7B838C" strokeWidth={4} d="M2 2v17h44V2H2z" />
      </g>
      <path
        d="M15.31 26.01h2.83V33h-1.5v-5.66h-1.33v-1.33zm7.335 2.725c.177-.25.265-.492.265-.725a.803.803 0 0 0-.23-.585.79.79 0 0 0-.59-.235c-.44 0-.857.313-1.25.94l-1.25-.74c.327-.507.685-.89 1.075-1.15.39-.26.887-.39 1.49-.39s1.133.192 1.59.575c.457.383.685.905.685 1.565 0 .36-.092.705-.275 1.035-.183.33-.522.752-1.015 1.265l-1.26 1.31h2.76V33h-4.93v-1.16l2.05-2.1c.413-.42.708-.755.885-1.005zm9.835-3.785h1.42l-4.2 9.17h-1.41l4.19-9.17zm5.27 2.39v-1.33h4.28v1.08l-1.43 1.63c.56.093.993.328 1.3.705.307.377.46.812.46 1.305 0 .733-.248 1.308-.745 1.725-.497.417-1.132.625-1.905.625-.773 0-1.557-.273-2.35-.82l.64-1.24c.66.467 1.25.7 1.77.7.313 0 .572-.077.775-.23.203-.153.305-.375.305-.665a.81.81 0 0 0-.35-.69c-.233-.17-.557-.255-.97-.255-.22 0-.53.063-.93.19v-1.15l1.34-1.58h-2.19zm5.57-1.33h2.83V33h-1.5v-5.66h-1.33v-1.33z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default DateInput;

